import { render, staticRenderFns } from "./M_computer.vue?vue&type=template&id=cb8541bc&scoped=true&"
import script from "./M_computer.vue?vue&type=script&lang=js&"
export * from "./M_computer.vue?vue&type=script&lang=js&"
import style0 from "./M_computer.vue?vue&type=style&index=0&id=cb8541bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8541bc",
  null
  
)

export default component.exports